<div class="social-links-container flex flex-col flex-center-center">
  <div class="social-links flex flex-between-center">
    <a
      class="link-linkedin flex flex-center-center"
      href="https://www.linkedin.com/company/7n/mycompany/"
      rel="noopener noreferrer"
      target="_blank"
    >
      <mat-icon svgIcon="linkedin"></mat-icon>
    </a>
    <a
      class="link-youtube flex flex-center-center"
      href="https://www.youtube.com/c/7NPoland"
      rel="noopener noreferrer"
      target="_blank"
    >
      <mat-icon svgIcon="youtube"></mat-icon>
    </a>
    <a
      class="link-website flex flex-center-center"
      href="https://www.7n.com/insights-overview/"
      rel="noopener noreferrer"
      target="_blank"
    >
      <mat-icon>public</mat-icon>
    </a>
  </div>
</div>
